import styled, { css } from '../../../../styled';
import colors from '../../../../themes/colors';
export const Column = styled.div `
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
`;
export function generateColumnButtonStyle({ isDefault, isSelected, isFromSelected, isToSelected, isDisabled, isPeriod, }, settings) {
    const { borderRadius = 4, defaultDateColor = colors.PRIMARY_600, hoverColor = colors.PRIMARY_200, selectedPointColor = colors.PRIMARY_600, selectedPointHoverColor = colors.PRIMARY_600, selectedPointHoverTextColor = colors.SNOW_100, selectedPointTextColor = colors.SNOW_100, selectedPointBorderRadius = 4, isSelectedPointCircle = false, periodColor = colors.PRIMARY_200, periodHoverColor = colors.PRIMARY_400, periodHoverTextColor = colors.INK_800, periodTextColor = colors.INK_800, disableColor = colors.SNOW_100, disableTextColor = colors.INK_400, headBackgroundColor, tailBackgroundColor, } = settings || {};
    return css `
    color: ${isDefault ? defaultDateColor : periodTextColor};
    font-weight: ${isDefault ? 600 : 'inherit'};
    cursor: pointer;
    border-radius: 0;

    :hover {
      background-color: ${hoverColor};
    }

    ${!isSelected &&
        !isFromSelected &&
        !isToSelected &&
        !isPeriod &&
        `
      :hover {
        border-radius: ${borderRadius}px;
      }
    `};

    ${(isSelected || isFromSelected || isToSelected) &&
        `
      background-color: ${selectedPointColor};
      color: ${selectedPointTextColor};

      :hover {
        background-color: ${selectedPointHoverColor};
        color: ${selectedPointHoverTextColor};
      }
    `};

    ${isFromSelected &&
        `
      border-top-left-radius: ${selectedPointBorderRadius}px;
      border-bottom-left-radius: ${selectedPointBorderRadius}px;
      ${isSelectedPointCircle
            ? `
          border-top-right-radius: ${selectedPointBorderRadius}px;
          border-bottom-right-radius: ${selectedPointBorderRadius}px;
          `
            : ''}
    `};

    ${isToSelected &&
        `
      border-top-right-radius: ${selectedPointBorderRadius}px;
      border-bottom-right-radius: ${selectedPointBorderRadius}px;
      ${isSelectedPointCircle
            ? `
          border-top-left-radius: ${selectedPointBorderRadius}px;
          border-bottom-left-radius: ${selectedPointBorderRadius}px;
          `
            : ''}
    `};

    ${isPeriod &&
        !(isSelected || isFromSelected || isToSelected) &&
        `
      background-color: ${periodColor};
      border-radius: ${borderRadius}px;

      :hover {
        background-color: ${periodHoverColor};
        color: ${periodHoverTextColor};
      }
    `};

    ${isDisabled &&
        `
      background-color: ${disableColor};
      color: ${disableTextColor};
      cursor: default;
      border-radius: ${borderRadius}px;

      :hover {
        background-color: ${disableColor};
      }
    `};
    ${isPeriod
        ? `
          position: relative;
          &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            width: 50%;
            height: 100%;
            background-color: ${headBackgroundColor || periodColor};
            ${isFromSelected && !headBackgroundColor
            ? `
                  border-top-left-radius: ${selectedPointBorderRadius}px;
                  border-bottom-left-radius: ${selectedPointBorderRadius}px;
                `
            : ''}
          }
          &::after {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            right: 0;
            z-index: -1;
            width: 50%;
            height: 100%;
            background-color: ${tailBackgroundColor || periodColor};
            ${isToSelected && !tailBackgroundColor
            ? `
                  border-top-right-radius: ${selectedPointBorderRadius}px;
                  border-bottom-right-radius: ${selectedPointBorderRadius}px;
                `
            : ''}
          }
        `
        : ''}
  `;
}
export const ColumnButton = styled(Column) `
  ${props => generateColumnButtonStyle(props)}
`;
//# sourceMappingURL=Column.js.map